import NotFound from './../components/sections/NotFound/NotFound';

const NotFoundPage = () => {
  return (
    <>
      <NotFound />
    </>
  );
};

export default NotFoundPage;